<adapt-feature-guidance [configItem]="configItem">
    <p>An owner's vision represents the long-term aspirations and future state that the business owner(s) want to achieve</p>
</adapt-feature-guidance>

<adapt-feature-configuration [team]="team"
                             [configItem]="configItem">
    <ng-container *adaptLoading="!isInitialised">
        <div class="d-flex flex-column gap-2">
            <div class="d-flex gap-3 align-items-center">
                <h3 class="my-0">Vision Categories</h3>
                <button adaptButton="addLink"
                        class="ms-auto"
                        [adaptBlockingClick]="addVisionCategory">Add vision category</button>
            </div>
            @if (visionCategories!.length === 0) {
                <p class="text-muted">No vision categories have been defined for this team. Use the button above to add one.</p>
            } @else {
                <dx-list [dataSource]="visionCategories"
                         [activeStateEnabled]="false"
                         [focusStateEnabled]="false"
                         [hoverStateEnabled]="false"
                         (onItemReordered)="reorderCategories($event)">
                    <dxo-list-item-dragging [data]="visionCategories"
                                            [allowReordering]="visionCategories!.length > 1"></dxo-list-item-dragging>
                    <div *dxTemplate="let category of 'item'">
                        <div class="d-flex flex-column gap-2">
                            <span (click)="categoryCollapsed[category.visionCategoryId] = !categoryCollapsed[category.visionCategoryId]"
                                  class="d-flex gap-2 align-items-center"
                                  role="button">
                                <b>{{ category.name }}</b>
                                <i class="fal"
                                   [ngClass]="{
                                        'fa-chevron-down': categoryCollapsed[category.visionCategoryId],
                                        'fa-chevron-up': !categoryCollapsed[category.visionCategoryId],
                                    }"></i>
                                <button class="ms-auto"
                                        adaptButton="editBorderless"
                                        adaptStopPropagation
                                        [adaptBlockingClick]="editVisionCategory"
                                        [adaptBlockingClickParam]="category"></button>
                                <button adaptButton="deleteBorderless"
                                        adaptStopPropagation
                                        [adaptBlockingClick]="deleteVisionCategory"
                                        [adaptBlockingClickParam]="category"></button>
                            </span>
                            <div [collapse]="categoryCollapsed[category.visionCategoryId]"
                                 [froalaView]="getCategoryDescription(category)"></div>
                        </div>
                    </div>
                </dx-list>
            }
        </div>
    </ng-container>
</adapt-feature-configuration>
